import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

// Layout passthrough for /create-password/* child routes.
// Direct navigation to /create-password (without a token) renders nothing useful,
// so redirect to login as a fallback. Users should arrive here via a password-reset
// email link that includes a token in the path.
export const Route = createFileRoute('/(public)/create-password')({
  beforeLoad: ({ location }) => {
    // Only redirect if this is an exact match on the parent route (no token segment).
    // Child routes like /create-password/:token are unaffected.
    if (location.pathname === '/create-password') {
      throw redirect({ to: '/login', replace: true });
    }
  },
  component: () => <Outlet />,
});
